import React, { useMemo } from 'react';
import { useNeighborhoods } from './useNeighborhoods';

type NeighborhoodsProviderProps = {
  children: React.ReactNode;
  floorId?: string;
};

// TODO: This context will become more useful if/when we add hover & select states to neighborhoods.
export type NeighborhoodsContextType = {
  neighborhoods: {
    id: string;
    name: string;
    colorDefinition: {
      base: string;
      label: {
        text: string;
        background: string;
      };
    };
    desks: {
      id: string;
    }[];
  }[];
  showColor?: boolean;
};

export const NeighborhoodsContext =
  React.createContext<NeighborhoodsContextType>({
    neighborhoods: [],
  });

export const NeighborhoodsProvider = ({
  children,
  floorId,
}: NeighborhoodsProviderProps): JSX.Element => {
  const data = useNeighborhoods(floorId);

  const neighborhoods = useMemo(() => {
    if (data?.neighborhoods) {
      // Transform the data to match the expected structure
      return data.neighborhoods.map((neighborhood) => ({
        id: neighborhood.id,
        name: neighborhood.name,
        colorDefinition: {
          base: neighborhood.colorDefinition.base,
          label: {
            text: neighborhood.colorDefinition.label.text,
            background: neighborhood.colorDefinition.label.background,
          },
        },
        desks: neighborhood.resources.map((resource) => ({
          id: resource.resourceId,
        })),
      }));
    }
    return [];
  }, [data]);

  const neighborhoodsApi = {
    neighborhoods,
    showColor: data?.showNeighborhoodColors,
  };

  return (
    <NeighborhoodsContext.Provider value={neighborhoodsApi}>
      {children}
    </NeighborhoodsContext.Provider>
  );
};
